<template>
  <div class="container">
    <h1>PHP Sending email example code</h1>
     <PhpGist />
  </div>
</template>
<script>
import PhpGist from './PhpGist'
export default {
  name: 'Php',
  components: {
    PhpGist
  }
}
</script>

<style scoped>
img{
  width: 90%;
}

</style>
